import React from 'react';
import { Col } from 'antd';
import './index.less';
import { map } from 'lodash';
import facebook from '../../assets/svgImg/socialMedia/face-fill@2x.svg';
import insta from '../../assets/svgImg/socialMedia/insta-fill@2x.svg';
import inIcon from '../../assets/svgImg/socialMedia/in-fill (1)@2x.svg';
import twitter from '../../assets/svgImg/socialMedia/twitter-fill (2)@2x.svg';

export default function SocialMedia() {
  const socialIcon = [
    { icon: <FbIcon />, link: 'https://www.facebook.com/Transformax-109686440862665' },
    { icon: <InstIcon />, link: 'https://www.instagram.com/maxtransformer/' },
    { icon: <InIcon />, link: 'https://www.linkedin.com/company/maxtransform/' },
    { icon: <TwitterIcon />, link: 'https://twitter.com/transformerMAX' },
  ];
  return (
    <Col className="social-media">
      <ul className="media-icon">
        {map(socialIcon, data => (
          <li onClick={() => window.open(data.link)}>{data.icon}</li>
        ))}
      </ul>
    </Col>
  );
}

const FbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width="10px"
    height="18px"
    viewBox="0 0 10 18"
    version="1.1"
  >
    <g id="landing-page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Landing-page-iteration-05" transform="translate(-1657.000000, -51.000000)">
        <g id="section-1" transform="translate(0.000000, -265.000000)">
          <g id="logo-+-links-+-Social" transform="translate(114.000000, 300.000000)">
            <g id="social" transform="translate(1446.000000, 14.000000)">
              <g id="facebook-fill-(2)" transform="translate(92.000000, 1.000000)">
                <polygon id="Path" points="0 0 20 0 20 20 0 20" />
                <path
                  d="M11.6666667,11.25 L13.75,11.25 L14.5833333,7.91666667 L11.6666667,7.91666667 L11.6666667,6.25 C11.6666667,5.39166667 11.6666667,4.58333333 13.3333333,4.58333333 L14.5833333,4.58333333 L14.5833333,1.78333333 C14.3116667,1.7475 13.2858333,1.66666667 12.2025,1.66666667 C9.94,1.66666667 8.33333333,3.0475 8.33333333,5.58333333 L8.33333333,7.91666667 L5.83333333,7.91666667 L5.83333333,11.25 L8.33333333,11.25 L8.33333333,18.3333333 L11.6666667,18.3333333 L11.6666667,11.25 Z"
                  id="Path"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const InstIcon = () => (
  <svg
    width="17px"
    height="18px"
    viewBox="0 0 17 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g id="landing-page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Landing-page-iteration-05" transform="translate(-1698.000000, -51.000000)">
        <g id="section-1" transform="translate(0.000000, -265.000000)">
          <g id="logo-+-links-+-Social" transform="translate(114.000000, 300.000000)">
            <g id="social" transform="translate(1446.000000, 14.000000)">
              <g id="instagram-fill" transform="translate(136.333333, 1.000000)">
                <polygon id="Path" points="0 0 20 0 20 20 0 20" />
                <path
                  d="M10,1.66666667 C12.2641667,1.66666667 12.5466667,1.675 13.435,1.71666667 C14.3225,1.75833333 14.9266667,1.8975 15.4583333,2.10416667 C16.0083333,2.31583333 16.4716667,2.6025 16.935,3.065 C17.3587447,3.48157997 17.686628,3.9854908 17.8958333,4.54166667 C18.1016667,5.0725 18.2416667,5.6775 18.2833333,6.565 C18.3225,7.45333333 18.3333333,7.73583333 18.3333333,10 C18.3333333,12.2641667 18.325,12.5466667 18.2833333,13.435 C18.2416667,14.3225 18.1016667,14.9266667 17.8958333,15.4583333 C17.6872305,16.0148138 17.3592672,16.5188475 16.935,16.935 C16.5183012,17.3585994 16.0144244,17.6864605 15.4583333,17.8958333 C14.9275,18.1016667 14.3225,18.2416667 13.435,18.2833333 C12.5466667,18.3225 12.2641667,18.3333333 10,18.3333333 C7.73583333,18.3333333 7.45333333,18.325 6.565,18.2833333 C5.6775,18.2416667 5.07333333,18.1016667 4.54166667,17.8958333 C3.98527181,17.6870611 3.48127268,17.3591204 3.065,16.935 C2.64117203,16.5184881 2.31327603,16.0145577 2.10416667,15.4583333 C1.8975,14.9275 1.75833333,14.3225 1.71666667,13.435 C1.6775,12.5466667 1.66666667,12.2641667 1.66666667,10 C1.66666667,7.73583333 1.675,7.45333333 1.71666667,6.565 C1.75833333,5.67666667 1.8975,5.07333333 2.10416667,4.54166667 C2.31269675,3.9851495 2.6406697,3.48110088 3.065,3.065 C3.48139248,2.64102602 3.98535715,2.3131077 4.54166667,2.10416667 C5.07333333,1.8975 5.67666667,1.75833333 6.565,1.71666667 C7.45333333,1.6775 7.73583333,1.66666667 10,1.66666667 Z M10,5.83333333 C7.69881354,5.83333333 5.83333333,7.69881354 5.83333333,10 C5.83333333,12.3011865 7.69881354,14.1666667 10,14.1666667 C12.3011865,14.1666667 14.1666667,12.3011865 14.1666667,10 C14.1666667,7.69881354 12.3011865,5.83333333 10,5.83333333 Z M15.4166667,5.625 C15.4166667,5.04970339 14.9502966,4.58333333 14.375,4.58333333 C13.7997034,4.58333333 13.3333333,5.04970339 13.3333333,5.625 C13.3333333,6.20029661 13.7997034,6.66666667 14.375,6.66666667 C14.9502966,6.66666667 15.4166667,6.20029661 15.4166667,5.625 Z M10,7.5 C11.3807119,7.5 12.5,8.61928813 12.5,10 C12.5,11.3807119 11.3807119,12.5 10,12.5 C8.61928813,12.5 7.5,11.3807119 7.5,10 C7.5,8.61928813 8.61928813,7.5 10,7.5 Z"
                  id="Shape"
                  fill="currentColor"
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const TwitterIcon = () => (
  <svg
    width="18px"
    height="14px"
    viewBox="0 0 18 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g id="landing-page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Landing-page-iteration-05" transform="translate(-1786.000000, -55.000000)">
        <g id="section-1" transform="translate(0.000000, -265.000000)">
          <g id="logo-+-links-+-Social" transform="translate(114.000000, 300.000000)">
            <g id="social" transform="translate(1446.000000, 14.000000)">
              <g id="twitter-fill-(2)" transform="translate(225.000000, 3.000000)">
                <polygon id="Path" points="0 0 20 0 20 20 0 20" />
                <path
                  d="M18.4683333,4.71333333 C17.8321308,4.99474477 17.1574667,5.17956115 16.4666667,5.26166667 C17.1947923,4.82619443 17.7397546,4.14084519 18,3.33333333 C17.3166667,3.74 16.5675,4.025 15.7866667,4.17916667 C14.7082079,3.02526626 12.9885646,2.74090753 11.5960552,3.48621077 C10.2035458,4.23151401 9.48635734,5.82012146 9.84833333,7.3575 C7.04585212,7.21703606 4.43478657,5.89332881 2.665,3.71583333 C2.35524176,4.24787526 2.19246262,4.85268894 2.19333333,5.46833333 C2.19333333,6.67666667 2.80833333,7.74416667 3.74333333,8.36916667 C3.19000734,8.35174685 2.64886033,8.20231713 2.165,7.93333333 L2.165,7.97666667 C2.16534433,9.63586316 3.33459535,11.0651026 4.96083333,11.3941667 C4.44717919,11.5333641 3.9085889,11.5538818 3.38583333,11.4541667 C3.84177248,12.8743192 5.15037619,13.8473148 6.64166667,13.875 C5.18161798,15.0216828 3.32561666,15.5409195 1.4825,15.3183333 C3.07558149,16.3428607 4.93008068,16.8867699 6.82416667,16.885 C13.235,16.885 16.7408333,11.5741667 16.7408333,6.96833333 C16.7408333,6.81833333 16.7366667,6.66666667 16.73,6.51833333 C17.4123868,6.02513972 18.0013323,5.41418283 18.4691667,4.71416667 L18.4683333,4.71333333 Z"
                  id="Path"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const InIcon = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g id="landing-page" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Landing-page-iteration-05" transform="translate(-1743.000000, -52.000000)">
        <g id="section-1" transform="translate(0.000000, -265.000000)">
          <g id="logo-+-links-+-Social" transform="translate(114.000000, 300.000000)">
            <g id="social" transform="translate(1446.000000, 14.000000)">
              <g id="linkedin-fill-(1)" transform="translate(180.666667, 1.000000)">
                <polygon id="Path" points="0 0 20 0 20 20 0 20" />
                <path
                  d="M5.78333333,4.16666667 C5.7828731,5.08714125 5.03630792,5.83296024 4.11583333,5.8325 C3.19535875,5.83203976 2.44953976,5.08547458 2.45,4.165 C2.45046024,3.24452542 3.19702542,2.49870643 4.1175,2.49916667 C5.03797458,2.4996269 5.78379357,3.24619208 5.78333333,4.16666667 Z M5.83333333,7.06666667 L2.5,7.06666667 L2.5,17.5 L5.83333333,17.5 L5.83333333,7.06666667 Z M11.1,7.06666667 L7.78333333,7.06666667 L7.78333333,17.5 L11.0666667,17.5 L11.0666667,12.025 C11.0666667,8.975 15.0416667,8.69166667 15.0416667,12.025 L15.0416667,17.5 L18.3333333,17.5 L18.3333333,10.8916667 C18.3333333,5.75 12.45,5.94166667 11.0666667,8.46666667 L11.1,7.06666667 Z"
                  id="Shape"
                  fill="currentColor"
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
